import ChartExamplesFirstLineCustomerSupport from "../../../../src/client/examples/json/first-line-customer-support.json";
import * as React from 'react';
export default {
  ChartExamplesFirstLineCustomerSupport,
  React
};